<template lang="pug">
  Modal(
    name="offline-reg-modal"
    align="center"
    ref="modal"
  )
    .base-modal__heading.base-modal__item
      .base-modal__top-img
        img(src="@/assets/img/illustrations/to-do-list-rafiki.svg" alt="")
      h3.base-modal__title Оффлайн регистрация
      .base-modal__subtitle Дорогой друг, электронная регистрация уже закрыта.
        |
        | Зарегистрироваться можно в&nbsp;месте выдачи стартовых пакетов.
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  name: 'OfflineRegModal',
  components: {
    Modal,
  },
};
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/utils/vars";
  @import "@/assets/scss/utils/mixins";
</style>
